import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';

import App from './pages/App';
import reportWebVitals from './reportWebVitals';
import { Analytics } from '@vercel/analytics/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <React.StrictMode>
        <GoogleOAuthProvider
                clientId={process.env.REACT_APP_OAUTH_ID}>
        <Analytics />
       <App />
       </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// // console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
